/* ------------------------------------------------------------------
   Labor Day 2026 storewide sale, display layer for the prices that are
   built by JavaScript instead of Liquid.

   Right now that is only the predictive-search dropdown, which renders
   its result cards from /search/suggest.json. Every other price on the
   site goes through snippets/sale-price.liquid.

   Keep SALE_PERCENT and the dates in sync with
   snippets/sale-price.liquid and with the automatic discount in admin.
   Outside the sale window this script returns immediately and does
   nothing, so it fails safe.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SALE_PERCENT = 20;
  var SALE_START = Date.UTC(2026, 7, 15, 7, 0, 0);
  var SALE_END = Date.UTC(2026, 8, 16, 6, 59, 59);

  var stamp = Date.now();
  if (stamp < SALE_START || stamp > SALE_END) return;

  /* suggest.json hands back a bare "56.00" with no currency symbol, which
     already looked odd on its own and looks worse next to a struck price.
     Add the symbol only when the string starts with a digit, so a properly
     formatted "$56.00" is left alone. */
  function withSymbol(text) {
    return /^\d/.test(text) ? '$' + text : text;
  }

  /* Takes the price string and returns it with the number reduced, so the
     shop's own formatting (symbol, separators) is preserved. */
  function reduce(text) {
    var match = String(text).match(/\d[\d.,]*/);
    if (!match) return null;
    var raw = match[0];
    var amount = parseFloat(raw.replace(/,/g, ''));
    if (!isFinite(amount) || amount <= 0) return null;
    var lowered = amount * (100 - SALE_PERCENT) / 100;
    var formatted = lowered.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return String(text).replace(raw, formatted);
  }

  function applyTo(el) {
    if (!el || el.getAttribute('data-sale-applied') === 'true') return;
    var original = (el.textContent || '').trim();
    if (!original) return;
    var lowered = reduce(original);
    if (!lowered || lowered === original) return;

    el.setAttribute('data-sale-applied', 'true');
    el.textContent = '';

    var was = document.createElement('span');
    was.className = 'sale-price__was';
    was.textContent = withSymbol(original);

    var now = document.createElement('span');
    now.className = 'sale-price__now';
    now.textContent = withSymbol(lowered);

    var wrap = document.createElement('span');
    wrap.className = 'sale-price';
    wrap.appendChild(was);
    wrap.appendChild(now);
    el.appendChild(wrap);
  }

  function sweep(root) {
    var nodes = (root || document).querySelectorAll('.psearch__product-price');
    Array.prototype.forEach.call(nodes, applyTo);
  }

  function watch() {
    var results = document.querySelector('[data-psearch-results]');
    if (!results) return;
    sweep(results);
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () { sweep(results); })
      .observe(results, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();